export const getDefaultIconDimensionsProps = (width: number, height: number) => ({ width, height });

export const getSvgDimensionsProps = ({ width, height }: { width: number, height: number }) => ({
  width,
  height,
});

export const getViewBoxProperty = ({ width, height }: { width: number, height: number }) => ({
  viewBox: `0 0 ${width} ${height}`,
});
